import { IconX } from "@tabler/icons-react";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import AddDriverModal from "./AddDriverModal";
import { useDriverCreateMutation } from "../../../apis/driverApis";
import { useState } from "react";
import { T, useLanguage } from "../../../context/LanguageContext";

interface Props {
  onClose: () => void;
}

export default function AddDriverSidebar({ onClose }: Props) {
  const { t } = useLanguage();
  const { mutate, isPending } = useDriverCreateMutation();
  const [allIds, setAllIds] = useState<any>();

  const getIds = (data: any) => {
    setAllIds(data);
  };

  const {
    register,
    handleSubmit,
    clearErrors,
    reset,
    setValue,
    watch,
    control,
    formState: { errors },
  } = useForm<any>();

  const handleCreate = (data: any) => {
    const merged = { ...data, ...allIds };
    const filtered = Object.fromEntries(
      Object.entries(merged).filter(
        ([_, value]) => value !== undefined && value !== null && value !== "",
      ),
    ) as any;

    mutate(filtered, {
      onSuccess: () => {
        toast.success(t("Driver Added Successfully."));
        reset();
        onClose();
      },
      onError: (error: any) => {
        console.error(error, "error");
        const errorMessage =
          error?.response?.data?.error?.message ||
          error?.response?.data?.message ||
          error?.message ||
          (typeof error === "string" ? error : null) ||
          "Something went wrong";

        toast.error(t(errorMessage));
      },
    });
  };

  return (
    <div className="relative bg-white rounded-3xl shadow-sm border flex flex-col overflow-hidden">
      <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200 bg-white">
        <h2 className="text-xl font-semibold text-[#212121]"><T>Add Driver</T></h2>

        <div className="flex items-center gap-3">
          <button
            onClick={handleSubmit(handleCreate)}
            disabled={isPending}
            className="px-4 py-2 bg-[#FBD037] text-[#212121] rounded-lg disabled:opacity-50"
          >
            {isPending ? t("Adding...") : t("Add")}
          </button>

          <button
            onClick={onClose}
            className="p-2 rounded-lg border border-[#D2D2D2]"
          >
            <IconX size={20} />
          </button>
        </div>
      </div> 
        <AddDriverModal
          register={register}
          errors={errors}
          clearErrors={clearErrors}
          setValue={setValue}
          getIds={getIds}
          watch={watch}
          control={control}
        /> 
    </div>
  );
}
